import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-new-signatureseries',
  templateUrl: './new-signatureseries.component.html',
  styleUrls: ['./new-signatureseries.component.scss']
})
export class NewSignatureseriesComponent implements OnInit,OnChanges {
  @Input() signatureseries:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  submitting=false;
  allcategories = []
  allinstructors = []
  tags=[];
  category="";
  instructor="";
  title="";
  description="";
  editor:any;
  imagefile:any=null;
  format:any;
  imageurl:any="";

  user:any
  Form: FormGroup = this.fb.group({
    title: ['', Validators.compose([Validators.required])],
    tags: [""],
    background:[""],
    category: ["",Validators.compose([Validators.required])],
    instructor: ["",Validators.compose([Validators.required])],
    description: [""]
  }); 

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  }

  onSelectFile(event) {
    const file = event.target.files && event.target.files[0];
    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      if(file.type.indexOf('image')> -1){
        this.imagefile=file;
        this.format = 'image';
      }
      reader.onload = (event) => {
        if(this.format=='image'){
          this.imageurl = (<FileReader>event.target).result;
        }
      }
    }
  }

  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.signatureseries){
      this.tags = this.signatureseries.tags;
      this.category=this.signatureseries.category_id;
      this.title=this.signatureseries.title;
      this.imageurl=(this.signatureseries.background && this.signatureseries.background!="")?this.getThumbUrl(this.signatureseries.background):"";
      this.instructor=this.signatureseries.instructor_id;
      this.description=this.signatureseries.description;;
      //this.gettagsRules(this.tags.id)
    }else{
      this.tags = [];
      this.category="";
      this.imageurl=null;
      this.title="";
      this.instructor="";
      this.description="";
    }
    this.initForm()
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
      this.getSignatureseriesFormData()
    },50)
    $(document).ready(() => {   
        setTimeout( ()=> { 
          $('.selectpicker').selectpicker('refresh');
        }, 100); 
    });  

    this.initForm()
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  handleEvent($event){
    if(!this.editor){
      this.editor=$event.editor
    }
  }

  
  getSignatureseriesFormData(){
    this.adminApi.setLoader(true)
    this.adminApi.getSignatureseriesFormData().subscribe((data: any) => {
      this.allcategories = data.categories
      this.allinstructors = data.instructors
      setTimeout( ()=> { 
        $('.selectpicker').selectpicker('refresh');
      }, 500); 
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }


  
  getUserData(){
    this.adminApi.setLoader(true)
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  initForm(){
    this.Form = this.fb.group({
      title: [this.title, Validators.compose([Validators.required])],
      tags: [this.tags],
      background: [""],
      instructor: [this.instructor, Validators.compose([Validators.required])],
      category: [this.category, Validators.compose([Validators.required])],
      description: [this.description],
    });

    if(this.editor){
      this.editor.setContent(this.description);
    }

    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      if(this.signatureseries){
        form.value.id=this.signatureseries.id
      }else{
        form.value.id="";
      }
      const formData = new FormData();
      formData.append('id',form.value.id);
      formData.append('title', form.value.title);
      formData.append('background', this.imagefile);
      formData.append('tags', form.value.tags);
      formData.append('instructor', form.value.instructor);
      formData.append('category', form.value.category);
      formData.append('description', form.value.description);
      this.adminApi.addSignatureseries(formData).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
          if(!this.signatureseries){
            this.imagefile="";
            this.imageurl="";
            form.reset();
          }
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      this.adminApi.validateAllFields(form);
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
